import { render, staticRenderFns } from "./CarouselRichModule.vue?vue&type=template&id=8d71c3da&"
import script from "./CarouselRichModule.ts?vue&type=script&lang=ts&"
export * from "./CarouselRichModule.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselRichModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports